import Modal from '@/components/common/Modal';
import Spacer from '@/components/common/Spacer';
import Text from '@/components/common/Text';
import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

interface Props {
  setIsShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedWorkers: number[];
  onConfirmDelete: () => void;
}

const DeleteWorkerModal = ({
  setIsShowModal,
  selectedWorkers,
  onConfirmDelete,
}: Props) => {
  return (
    <Modal
      setIsModalOpen={setIsShowModal}
      title='작업자 삭제'
      width='31.25rem'
      isWarning
      onClickConfirm={onConfirmDelete}
      confirmText='삭제'
    >
      <Spacer y='1.875rem' />
      <Text fontSize='1.375rem' fontWeight={700} textAlign='center'>
        선택한 작업자({selectedWorkers.length}명)를 삭제하시겠습니까?
      </Text>
      <Spacer y='1.25rem' />
      <WarningBox>
        <Text fontSize='1rem' fontWeight={500} color={Theme.colors.WARNING_RED}>
          ⚠️ 삭제된 작업자는 즉시 로그인할 수 없습니다.
        </Text>
        <Spacer y='0.75rem' />
        <Text fontSize='0.875rem' fontWeight={400} color={Theme.colors.G_1}>
          • 삭제된 작업자는 "작업자 추가/복구" 메뉴에서 복구할 수 있습니다.
          <br />• 작업자 데이터는 보존되며, 복구 시 즉시 사용 가능합니다.
        </Text>
      </WarningBox>
      <Spacer y='2.5rem' />
    </Modal>
  );
};

export default DeleteWorkerModal;

const WarningBox = styled.div`
  width: 100%;
  padding: 1rem;
  background-color: ${Theme.colors.G_6};
  border: 0.0625rem solid ${Theme.colors.G_4};
  border-radius: 0.5rem;
`;

